export function formatDurationToHourMinute(totalSeconds: number) {
  const safeSeconds = Number.isFinite(totalSeconds)
    ? Math.max(0, totalSeconds)
    : 0;
  const totalMinutes = Math.floor(safeSeconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function extractDatePart(value: Date) {
  return new Date(
    value.getFullYear(),
    value.getMonth(),
    value.getDate(),
    0,
    0,
    0,
    0,
  );
}

export function extractTimePart(value: Date) {
  return new Date(1970, 0, 1, value.getHours(), value.getMinutes(), 0, 0);
}

export function combineDateAndTime(date: Date, time?: Date | null) {
  const hours = time ? time.getHours() : 0;
  const minutes = time ? time.getMinutes() : 0;
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    hours,
    minutes,
    0,
    0,
  );
}

export function parseHourMinuteToDuration(value: string) {
  const raw = String(value || "").trim();
  const match = raw.match(/^(\d{1,3}):(\d{2})$/);
  if (!match) return null;
  const [, hours, minutes] = match;
  const h = Number(hours);
  const m = Number(minutes);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  if (h < 0) return null;
  if (m < 0 || m > 59) return null;
  return Math.max(0, h * 3600 + m * 60);
}
